import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/settings_/form-templates_/create")({
	loader: ({ context: { queryClient }, deps }) => {},
	component: lazyRouteComponent(() => import("@/features/dashboard/pages/settings.form-templates.create")),
});
